"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ExamplesTabContent;
var _react = _interopRequireWildcard(require("react"));
var _reactComponents = require("@synerg/react-components");
var _lodash = require("lodash");
require("../../../shared/projects.scss");
var _scenarioContent = _interopRequireDefault(require("./scenarioContent"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ExamplesTabContent(_ref) {
  var operationDetailsExamples = _ref.operationDetailsExamples,
    operationPath = _ref.operationPath,
    httpMethod = _ref.httpMethod;
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    exampleSectionTabValue = _useState2[0],
    setExampleSectionTabValue = _useState2[1];
  var getScenarioNumber = function getScenarioNumber(scenario) {
    var _scenario$name$match;
    return parseInt((_scenario$name$match = scenario.name.match(/\d+/)) === null || _scenario$name$match === void 0 ? void 0 : _scenario$name$match[0]);
  };
  function sortScenarios(scenarios) {
    var splitedScenarios = scenarios.reduce(function (acc, value) {
      var valueIsNan = isNaN(parseInt(value.name));
      if (valueIsNan && !getScenarioNumber(value)) {
        acc.withoutNumbers.push(value);
      } else if (valueIsNan) {
        acc.withoutPrefix.push(value);
      } else {
        acc.withPrefix.push(value);
      }
      return acc;
    }, {
      withPrefix: [],
      withoutPrefix: [],
      withoutNumbers: []
    });
    var sortedScenarios = [].concat(_toConsumableArray(splitedScenarios.withPrefix.sort(function (a, b) {
      return parseInt(a.name) < parseInt(b.name) ? -1 : 1;
    })), _toConsumableArray(splitedScenarios.withoutPrefix.sort(function (a, b) {
      return getScenarioNumber(a) < getScenarioNumber(b) ? -1 : 1;
    })), _toConsumableArray(splitedScenarios.withoutNumbers));
    return sortedScenarios;
  }
  var scenarios = sortScenarios((0, _lodash.get)(operationDetailsExamples, 'scenarios', []));
  (0, _react.useEffect)(function () {
    setExampleSectionTabValue(0);
  }, [operationDetailsExamples]);
  var onExampleSectionTabChange = function onExampleSectionTabChange(index) {
    setExampleSectionTabValue(index);
  };
  var handleEmptyState = function handleEmptyState(textHeading) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "mt-24 flex flex-col items-center mb-16"
    }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfSpotIllustration, {
      illustrationName: "empty-skills",
      size: "md"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "mt-10 text-center"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "text-2xl font-bold leading-xs tracking-xs text-heading-04 text-tertiary"
    }, "No ", textHeading, " provided")));
  };
  var selectedScenario = scenarios.length > 0 && scenarios[exampleSectionTabValue] ? scenarios[exampleSectionTabValue] : {};
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "ml-4 mt-3 md:col-span-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-heading-05 font-black mb-1 -mt-4 mb-4"
  }, "Example(s)"), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-heading-03 font-bold"
  }, "Example scenarios"), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-body-02 mb-8"
  }, "Select an example from the list below to view description, code samples and parameters used."), scenarios.length === 0 && /*#__PURE__*/_react.default.createElement("div", null, handleEmptyState('examples')), scenarios.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-4 md:grid md:grid-cols-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "lg:w-60 w-min sm:col-end-1 w-72 bg-action-default-100 h-auto overflow-y-scroll flex"
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfTabGroup, {
    vertical: true,
    size: "small",
    role: "tablist",
    onSdfChange: function onSdfChange(event) {
      return onExampleSectionTabChange(event.detail.value);
    }
  }, scenarios.map(function (scenario, index) {
    return /*#__PURE__*/_react.default.createElement(_reactComponents.SdfTab, {
      key: index,
      className: index === exampleSectionTabValue ? "w-72 vertical-tab layout-vertical size-small first-in-group postman-button-box text-heading-01 block truncate overflow-ellipsis" : "w-72 vertical-tab layout-vertical size-small first-in-group postman-button-box text-heading-01 block truncate overflow-ellipsis text-link",
      value: index,
      active: index === exampleSectionTabValue
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "w-52"
    }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfTooltip, {
      trigger: "hover",
      state: "neutral",
      tooltipId: (0, _lodash.uniqueId)(),
      attachmentPoint: 'auto',
      portalEnabled: 'true'
    }, /*#__PURE__*/_react.default.createElement("div", {
      slot: "tooltip-target",
      className: "overflow-ellipsis overflow-hidden"
    }, scenario.name), /*#__PURE__*/_react.default.createElement("div", null, scenario.name))));
  }))), /*#__PURE__*/_react.default.createElement(_scenarioContent.default, {
    scenario: selectedScenario,
    handleEmptyState: handleEmptyState,
    operationPath: operationPath,
    httpMethod: httpMethod
  }))));
}